module.exports = __webpack_public_path__ + "static/media/tariffs.a923d2c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tariffs.svg
// module id = 1594
// module chunks = 0